import { Fragment } from 'react'

import { formatInteger } from '../../demo/format'
import { useResultDisplay, useRisksOf, useViolationsOf } from '../../demo/selectors'
import type { Campaign } from '../../demo/types'
import { GlossaryText, Icon, ProgressBar, Term } from '../../ui'
import { riskSummary, violationLabel } from './compliance'
import styles from './ResultCell.module.css'

const footTermKeys: Record<string, string> = { CPA: 'cpa', ROAS: 'roas', CPM: 'cpm' }

export function ResultCell({ campaign }: { campaign: Campaign }) {
  const display = useResultDisplay(campaign)
  const violations = useViolationsOf(campaign.id)
  const risks = useRisksOf(campaign.id)

  return (
    <div className={styles.result}>
      <p className={styles.top}>{display.metricLabel} <b>{formatInteger(display.current)} / {formatInteger(display.target)}</b></p>
      <ProgressBar value={display.percent} />
      <p className={styles.foot}>
        <span className={styles.metricPair}>完成 <b>{display.percent}%</b></span>
        {display.footItems.map((item) => {
          const separator = item.indexOf(' ')
          const label = item.slice(0, separator)
          const value = item.slice(separator + 1)
          return <Fragment key={item}>{'\u3000·\u3000'}<span className={styles.metricPair}>{footTermKeys[label] ? <Term k={footTermKeys[label]} /> : label} <b>{value}</b></span></Fragment>
        })}
      </p>
      {display.warn ? <p className={styles.warn}><Icon name="alert" size={15} strokeWidth={1.9} />{display.warn}</p> : null}
      {violations.length > 0 ? <p className={styles.warn}><Icon name="alert" size={15} strokeWidth={1.9} /><GlossaryText text={violationLabel(violations)} /></p> : null}
      {risks.length > 0 ? <p className={`${styles.warn} ${styles.warnRisk}`}><Icon name="alert" size={15} strokeWidth={1.9} /><GlossaryText text={riskSummary(risks)} /></p> : null}
    </div>
  )
}
